export const scrollToId = (id) => {
  const element = document.getElementById(id.slice(1));
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};
